import { Injectable } from '@angular/core';
import { NgxDeviceInfoService } from 'ngx-device-info';

@Injectable({
    providedIn: 'root',
})
export class CihazKimlikService {
    private readonly localStorageKey = 'cihaz_kimlik'; // LocalStorage anahtarı
    private cachedDeviceId: string | null = null;
    public bilgiler: any = {};

    constructor(public device: NgxDeviceInfoService) {
        device.getDeviceInfo().then((data) => {
            this.bilgiler = data;
        });
    }

    /**
     * Her seferinde aynı cihaz kimliğini döndürür.
     * Tarayıcıda veri sıfırlansa bile aynı ID'yi oluşturur.
     */
    get kimlik(): string | any {
        if (this.cachedDeviceId) {
            return this.cachedDeviceId;
        }

        // 1. LocalStorage'dan cihaz kimliğini al
        let deviceId = localStorage.getItem(this.localStorageKey);

        // Eğer cihaz kimliği yoksa, yeni bir kimlik oluştur ve sakla
        if (!deviceId) {
            deviceId = this.fikoIdUret();
            localStorage.setItem(this.localStorageKey, deviceId);
        }

        this.cachedDeviceId = deviceId;
        return deviceId;
    }

    /**
     * Aynı cihazda her zaman aynı kimliği döndürür.
     * Bu kimlik her seferinde sabit kalır.
     */
    private generateDeviceId(): string {
        const salt = 'unique-device-salt'; // Gizli anahtar (salt), sabit olmalı
        const userAgent = navigator.userAgent; // Tarayıcı bilgisi
        const platform = navigator.platform; // Cihaz platformu
        const screenWidth = window.screen.width; // Ekran genişliği
        const screenHeight = window.screen.height; // Ekran yüksekliği
        const language = navigator.language; // Dil bilgisi
        const colorDepth = window.screen.colorDepth; // Ekran renk derinliği

        // Tüm cihaz ve tarayıcı verilerini birleştir
        const rawData = [
            userAgent,
            platform,
            language,
            screenWidth,
            screenHeight,
            colorDepth,
            salt, // Gizli anahtar ekleniyor
            new Date().toISOString()
        ].join('-');

        // Hash fonksiyonu kullanarak benzersiz bir kimlik oluştur
        return this.simpleHash(rawData);
    }

    /**
     * Basit bir hash fonksiyonu ile metni hashler.
     * @param input: Cihaz verilerinin birleştirilmiş hali
     */
    private simpleHash(input: string): string {
        let hash = 0;
        for (let i = 0; i < input.length; i++) {
            const char = input.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash |= 0; // 32-bit sayıya dönüştür
        }
        return Math.abs(hash).toString(); // Pozitif bir değer döndür
    }



    public fikoIdUret(): string {
        // tslint:disable-next-line:no-bitwise
        const timestamp = (new Date().getTime() / 1000 | 0).toString(16);
        return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
            // tslint:disable-next-line:no-bitwise
            return (Math.random() * 16 | 0).toString(16);
        }).toLowerCase();
    }

    /**
     * Cihaz kimliğini temizler (test veya geliştirme amaçlı).
     */
    clearDeviceId(): void {
        localStorage.removeItem(this.localStorageKey);
        this.cachedDeviceId = null;
    }

}
